module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "relatorios-historico-container",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "equal-heights pa-5 historico-layout",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.por === 'data') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('ul', {
    staticClass: "opcoes"
  }, [_c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'recentes'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('recentes')
      }
    }
  }, [_c('strong', [_vm._v("mais recentes")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'dia'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('dia')
      }
    }
  }, [_c('strong', [_vm._v("dia")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'semana'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('semana')
      }
    }
  }, [_c('strong', [_vm._v("semana")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'mes'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('mes')
      }
    }
  }, [_c('strong', [_vm._v("mês")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'semestre'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('semestre')
      }
    }
  }, [_c('strong', [_vm._v("semestre")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'ano'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('ano')
      }
    }
  }, [_c('strong', [_vm._v("ano")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'custom'
    }
  }, [_c('v-menu', {
    attrs: {
      "full-width": "",
      "offset-y": "",
      "close-on-content-click": false,
      "bottom": ""
    },
    model: {
      value: (_vm.dateMenu),
      callback: function($$v) {
        _vm.dateMenu = $$v
      },
      expression: "dateMenu"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("por período")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('DateRange', {
    attrs: {
      "options": _vm.dateRangeOptions,
      "no-presets": ""
    },
    on: {
      "input": _vm.onDateRangeChange
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.changePeriodoCustom($event)
      }
    }
  }, [_vm._v("Aplicar")])], 1)], 1)], 1)], 1)])]) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('ul', {
    staticClass: "opcoes"
  }, _vm._l((_vm.users), function(user) {
    return _c('li', {
      class: {
        'ativo': _vm.userSelecionado === user.id
      },
      on: {
        "click": function($event) {
          _vm.changeUserSelecionado(user.id)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(user.name))])])
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-3 px-4 py-3 historico-card",
    staticStyle: {
      "min-height": "70vh"
    }
  }, [(_vm.paginacao.total > 0) ? _c('v-card-text', [_vm._l((_vm.historico), function(dia, index) {
    return _c('div', {
      staticClass: "alteracao"
    }, [_c('p', {
      staticClass: "data alteracao-data"
    }, [_vm._v(_vm._s(_vm.formatData(index)))]), _vm._v(" "), _vm._l((dia), function(alteracoes) {
      return _c('div', {
        staticClass: "alteracao-imovel"
      }, [_c('div', {
        staticClass: "alteracao-imovel-apelido"
      }, [(alteracoes[0]['apelido']) ? _c('strong', [_vm._v(_vm._s(alteracoes[0]['apelido']))]) : _vm._e(), _vm._v(" "), (alteracoes[0]['endereco']) ? [_vm._v("\n                       " + _vm._s(_vm.formatEndereco(alteracoes[0]['endereco'])) + "\n                  ")] : _vm._e()], 2), _vm._v(" "), _vm._l((alteracoes), function(alteracao) {
        return _c('div', {
          staticClass: "alteracao-tipo"
        }, [(alteracao['event'] === 'created') ? [(_vm.formatType(alteracao['auditable_type']) === 'Imóvel') ? [_c('span', {
          staticClass: "data"
        }, [_vm._v("Imóvel criado às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])])] : [_c('span', {
          staticClass: "data"
        }, [_vm._v("Criação de " + _vm._s(_vm.formatType(alteracao['auditable_type'])) + " às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])]), _vm._v(" "), _vm._l((alteracao['new_values']), function(new_value, new_value_index) {
          return (new_value !== '' && new_value !== null) ? _c('div', [_vm._v("\n                        " + _vm._s(_vm.formatColunaName(new_value_index)) + ":\n                        "), _c('strong', {
            staticClass: "valor-novo"
          }, [_vm._v(_vm._s(_vm.formatValue(alteracao['new_values'][new_value_index], new_value_index)))])]) : _vm._e()
        })]] : _vm._e(), _vm._v(" "), (alteracao['event'] === 'deleted') ? [(_vm.formatType(alteracao['auditable_type']) === 'Imóvel') ? [_c('span', {
          staticClass: "data"
        }, [_vm._v("Imóvel removido às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])])] : [_c('span', {
          staticClass: "data"
        }, [_vm._v("Remoção de " + _vm._s(_vm.formatType(alteracao['auditable_type'])) + " às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])]), _vm._v(" "), _vm._l((alteracao['old_values']), function(old_value, old_value_index) {
          return _c('div', [_vm._v("\n                        " + _vm._s(_vm.formatColunaName(old_value_index)) + ":\n                        "), _c('strong', {
            staticClass: "valor-antigo"
          }, [_vm._v(_vm._s(_vm.formatValue(old_value, old_value_index)))])])
        })]] : (alteracao['event'] === 'updated') ? [_c('span', {
          staticClass: "data"
        }, [_vm._v("Alteração de " + _vm._s(_vm.formatType(alteracao['auditable_type'])) + " às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])]), _vm._v(" "), _vm._l((alteracao['old_values']), function(old_value, old_value_index) {
          return _c('div', [_vm._v("\n                      " + _vm._s(_vm.formatColunaName(old_value_index)) + ":\n                      "), _c('strong', {
            staticClass: "valor-novo"
          }, [_vm._v(_vm._s(_vm.formatValue(alteracao['new_values'][old_value_index], old_value_index)))]), _vm._v(" "), (alteracao['new_values'][old_value_index] !== '' && alteracao['new_values'][old_value_index] !== null && old_value !== '' && old_value !== null) ? _c('span', [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), _c('strong', {
            staticClass: "valor-antigo"
          }, [_vm._v(_vm._s(_vm.formatValue(old_value, old_value_index)))])])
        })] : _vm._e()], 2)
      })], 2)
    })], 2)
  }), _vm._v(" "), (_vm.paginacao !== undefined && _vm.paginacao.current_page < _vm.paginacao.total_pages) ? _c('div', {
    staticClass: "secondary--text text-xs-center subheading my-5"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.loadHistorico(_vm.paginacao.current_page + 1)
      }
    }
  }, [_vm._v("CARREGAR MAIS")])]) : _vm._e()], 2) : _c('v-card-text', [_c('div', {
    staticClass: "subheading text-xs-center pt-5"
  }, [_vm._v("Nenhum resultado encontrado. Experimente remover os filtros de imóveis.")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34552b44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relatorios/RelatoriosHistorico.vue
// module id = 1004
// module chunks = 1